/**
 * Mobile menu overlay (Figma MORE G).
 *
 * The header burger opens it; the close button, Escape, or growing the
 * viewport to the desktop layout closes it. Focus moves into the dialog on
 * open and back to the burger on close; the page behind is scroll-locked.
 */
import { DESKTOP, onMediaChange } from './media.js';

export function initMobileMenu() {
  const menu = document.getElementById('hp-mmenu');
  if (!menu) return;

  const openers = [...document.querySelectorAll('[data-menu-open]')];
  let returnFocus = null;

  const setExpanded = (value) => openers.forEach((b) => b.setAttribute('aria-expanded', String(value)));

  const open = () => {
    returnFocus = document.activeElement;
    menu.hidden = false;
    document.documentElement.classList.add('is-menu-open');
    setExpanded(true);
    (menu.querySelector('[data-menu-close]') || menu.querySelector('a, button'))?.focus();
  };

  const close = () => {
    if (menu.hidden) return;
    menu.hidden = true;
    document.documentElement.classList.remove('is-menu-open');
    setExpanded(false);
    if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus();
  };

  openers.forEach((b) => b.addEventListener('click', open));
  menu.querySelectorAll('[data-menu-close]').forEach((b) => b.addEventListener('click', close));
  document.addEventListener('keydown', (e) => {
    if (menu.hidden) return;
    if (e.key === 'Escape') {
      close();
    } else if (e.key === 'Tab') {
      // aria-modal: keep Tab inside the open menu (it walked out into the
      // bottom nav and the page behind), as the mobile search does.
      const focusable = [...menu.querySelectorAll('a[href], button, input')].filter((el) => el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  onMediaChange(window.matchMedia(DESKTOP), (e) => { if (e.matches) close(); });
}
